var map = {
	"./desserts/biscuit.svg": 793,
	"./desserts/compote.svg": 794,
	"./desserts/fromage.svg": 795,
	"./desserts/fruits-secs.svg": 796,
	"./desserts/gateau.svg": 797,
	"./desserts/glace.svg": 798,
	"./desserts/jus.svg": 799,
	"./desserts/salade-fruits.svg": 800,
	"./desserts/tarte.svg": 801,
	"./desserts/yaourt.svg": 802,
	"./feculents/ble.svg": 803,
	"./feculents/pain.svg": 804,
	"./feculents/pates.svg": 805,
	"./feculents/pomme-de-terre.svg": 806,
	"./feculents/riz.svg": 807,
	"./feculents/semoule.svg": 808,
	"./fruits/abricot.svg": 809,
	"./fruits/ananas.svg": 810,
	"./fruits/banane.svg": 811,
	"./fruits/cerises.svg": 812,
	"./fruits/clementines.svg": 813,
	"./fruits/fraises.svg": 814,
	"./fruits/kiwi.svg": 815,
	"./fruits/mangue.svg": 816,
	"./fruits/melon.svg": 817,
	"./fruits/nectarine.svg": 818,
	"./fruits/orange.svg": 819,
	"./fruits/pamplemousse.svg": 820,
	"./fruits/pasteque.svg": 821,
	"./fruits/peche.svg": 822,
	"./fruits/poire.svg": 823,
	"./fruits/pomme.svg": 824,
	"./fruits/prune.svg": 825,
	"./fruits/raisin.svg": 826,
	"./legumes/Artichauts.svg": 827,
	"./legumes/Choux-de-bruxelles.svg": 828,
	"./legumes/asperges.svg": 829,
	"./legumes/aubergines.svg": 830,
	"./legumes/betteraves.svg": 831,
	"./legumes/brocolis.svg": 832,
	"./legumes/carottes.svg": 833,
	"./legumes/celeris.svg": 834,
	"./legumes/champignons.svg": 835,
	"./legumes/choux-fleur.svg": 836,
	"./legumes/choux.svg": 837,
	"./legumes/concombres.svg": 838,
	"./legumes/courge.svg": 839,
	"./legumes/courgette.svg": 840,
	"./legumes/cresson.svg": 841,
	"./legumes/epinards.svg": 842,
	"./legumes/fenouils.svg": 843,
	"./legumes/haricots.svg": 844,
	"./legumes/laitues.svg": 845,
	"./legumes/mais.svg": 846,
	"./legumes/navets.svg": 847,
	"./legumes/petits-pois.svg": 848,
	"./legumes/poireaux.svg": 849,
	"./legumes/poivrons.svg": 850,
	"./legumes/potage.svg": 851,
	"./legumes/radis.svg": 852,
	"./legumes/salade.svg": 853,
	"./legumes/tomates.svg": 854,
	"./proteines/agneau.svg": 855,
	"./proteines/lait-de-soja.svg": 856,
	"./proteines/oeuf-au-plat.svg": 857,
	"./proteines/oeuf-brouilles.svg": 858,
	"./proteines/oeufs.svg": 859,
	"./proteines/omelette.svg": 860,
	"./proteines/poisson.svg": 861,
	"./proteines/porc.svg": 862,
	"./proteines/viande.svg": 863,
	"./proteines/volaille.svg": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 792;